import { useState } from 'react'

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'

interface CopyableTextProps {
  text: string
  className?: string
}

export function CopyableText({ text, className }: CopyableTextProps) {
  const [copied, setCopied] = useState(false)
  const [open, setOpen] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true)
      setOpen(true)
      setTimeout(() => {
        setCopied(false)
        setOpen(false)
      }, 1500)
    })
  }

  return (
    <TooltipProvider>
      {/* Help Icon */}
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          <span onClick={handleCopy} className={`cursor-pointer select-all ${className}`}>
            {text}
          </span>
        </TooltipTrigger>
        <TooltipContent side='top' align='center' sideOffset={5}>
          <p>{copied ? 'Copied!' : 'Click to copy'}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
